<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Innstillinger - {{name}}</h4>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" @click="handleSubmit()" class="button primary">Lagre endringer</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary" disabled>Lagre<span class="show-for-medium"> endringer</span></a>
      </div>
    </div>

    <TheLoader :active="$store.getters.isFormLoading"/>
    <div v-if="!$store.getters.isFormLoading" class="content-container flex-row">
      <section class="content large-padding fixed-width small scrollnav">
        <form @submit.prevent="handleSubmit">
          <fieldset>
            <div class="grid-x grid-padding-x">
              <TheTextInput containerClassName="cell large-6" label="Kundekategoritypeid" v-model.trim="item.Kundekategoritypeid" :disabled="true"/>
              <TheTextInput containerClassName="cell large-6" label="Kategorikode" name="Kategorikode" :disabled="edit" v-model.trim="item.Kategorikode" maxlength="10" required v-validate="'required|max:10'"/>
              <TheTextInput containerClassName="cell large-6" label="Beskrivelse" name="Beskrivelse" v-model.trim="item.Beskrivelse" maxlength="100" v-validate="'max:100'"/>

              <TheSelectInput containerClassName="cell large-6" label="Dokumenttypeid" name="Dokumenttypeid" v-model.trim="item.Dokumenttypeid" :items="dokumenttypeOptions"/>
            </div>
          </fieldset>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import InstillingerService from '@/services/InstillingerService'

export default {
  name: 'InstillingerKundekategoritypeEdit',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    servicename: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      service: InstillingerService(this.servicename),
      edit: false,
      item: {},
      dokumenttypeOptions: [],
      loading: true
    }
  },
  created () {
    // Set form to loading
    this.setFormLoading(true)

    // Edit mode
    this.edit = !!this.$route.params.id

    // Load
    this.fetch()
  },
  methods: {
    fetch: function () {
      this.dokumenttypeOptions.unshift({key: this.item.Dokumenttypeid, val: 'Laster...'})

      InstillingerService('dokumenttype').dropdown('id')
        .then((response) => {
          this.dokumenttypeOptions = response.data
          this.dokumenttypeOptions.unshift({key: null, val: 'Velg dokumenttype'})

          if (!this.edit) {
            this.setFormLoading(false)
          } else {
            this.service.view(this.$route.params.id)
              .then((response) => {
                this.item = response.data
              })
              .catch(() => {
                this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn kundekategoritype')

                this.onCancel()
              })
              .then(() => {
                this.setFormLoading(false)
              })
          }
        })
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            // Force code to be uppercase
            this.item.Kategorikode = this._.toUpper(this.item.Kategorikode)

            this.service.save(this.item.Kundekategoritypeid, this.item)
              .then((response) => {
                this.$helpers.showSuccessAlert('Kundekategoritype er lagret')

                this.item = response.data

                if (!this.edit) {
                  this.$router.go(-1)
                }
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                } else {
                  this.$helpers.showErrorAlert('Feil', 'Noe gikk galt, prøv igjen', 'danger')
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    onCancel: function () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
input[name="Kategorikode"] {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/InstillingerKundekategoritypeEdit.vue